import { useCallback } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import xor from 'lodash-es/xor'

import { IPlayer } from 'protos'
import config from 'config'

const { TEAM_SIZE } = config

const usePlayersViaURL = ({
  availablePlayers,
}: {
  availablePlayers: IPlayer[] | null | undefined
}) => {
  const query = new URLSearchParams(useLocation().search)
  const playerIdsAsString = query.get('players')

  const selectedPlayers = ((availablePlayers && playerIdsAsString && playerIdsAsString.split(',')) || [])
    .map(playerId => availablePlayers?.find(player => player.playerId === playerId))
    .filter(Boolean) as IPlayer[]

  const selectedPlayerIds = selectedPlayers.map(player => player.playerId!)

  const { replace } = useHistory()
  const setSelectedPlayerIds = useCallback((playerIds: string[]) => {
    const newPlayerIds = playerIds.splice(0, TEAM_SIZE)

    if (newPlayerIds.length > 0) {
      query.set('players', newPlayerIds.join(','))
    } else {
      query.delete('players')
    }

    replace({ search: query.toString() })
  }, [query, replace])

  const togglePlayer = useCallback(
    (player: IPlayer) => setSelectedPlayerIds(xor(selectedPlayerIds, [player.playerId!])),
    [selectedPlayerIds, setSelectedPlayerIds],
  )

  return {
    selectedPlayers,
    togglePlayer,
    setSelectedPlayerIds,
  }
}

export default usePlayersViaURL
try {
    // @ts-ignore
    usePlayersViaURL.displayName = "usePlayersViaURL";
    // @ts-ignore
    usePlayersViaURL.__docgenInfo = { "description": "", "displayName": "usePlayersViaURL", "props": { "availablePlayers": { "defaultValue": null, "description": "", "name": "availablePlayers", "required": true, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TeamEditor/hooks/usePlayersViaURL.tsx#usePlayersViaURL"] = { docgenInfo: usePlayersViaURL.__docgenInfo, name: "usePlayersViaURL", path: "src/components/TeamEditor/hooks/usePlayersViaURL.tsx#usePlayersViaURL" };
}
catch (__react_docgen_typescript_loader_error) { }